import { defineNuxtPlugin } from 'nuxt/app'
import { buildProxyRequestHeaders } from '~~/helpers/request'

/**
 * This is only called when performing a query or mutation from within the nuxt
 * app (e.g. not via custom server routes).
 */
export default defineNuxtPlugin({
  name: 'lessmess:graphql-plugin',
  dependsOn: ['nuxt-graphql-middleware-provide-state', 'nuxt:router'],
  setup() {
    const state = useGraphqlState()

    const event = import.meta.server ? useRequestEvent() : undefined

    if (!state) {
      throw new Error('Missing nuxt-graphql-middleware state.')
    }

    if (import.meta.server && event) {
      state.fetchOptions.headers = buildProxyRequestHeaders(event)
    }

    state.fetchOptions.onResponse = (result) => {
      const data = result.response?._data
      if (!data) {
        return
      }

      if (import.meta.server && event) {
        useGraphqlCacheability(event, result.response?._data)
      }
    }
  },
})
